<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{
                name: 'RegisterCollaboratorCompany',
                params: {
                  id: $route.params.id,
                  slug: $route.params.slug,
                },
              }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasCompanyCollaborators">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="collaborator in companyCollaborators"
              :key="collaborator.id"
            >
              <CardCompanyCollaborator :collaborator="collaborator" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardCompanyCollaborator from "@/views/Company/components/CardCompanyCollaborator";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Empresas",
          routerName: "ListCompanies",
        },
        {
          name: "Menu Empresa",
          routerName: "MenuCompany",
        },
        {
          name: "Colaboradores",
          routerName: "ListCollaboratorsCompany",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("Company", ["companyCollaborators"]),
    hasCompanyCollaborators() {
      return (
        this.companyCollaborators &&
        Array.isArray(this.companyCollaborators) &&
        this.companyCollaborators.length > 0
      );
    },
    hasParams() {
      return this.$route.params && Object.keys(this.$route.params).length > 0;
    },
  },
  components: {
    Breadcrumb,
    CardCompanyCollaborator,
  },
  methods: {
    ...mapActions("Company", ["consultCompanyCollaborators", "setDataDefault"]),
    handleDataBreadcrumb() {
      this.links[2].name = `Menu - ${this.$route.params.slug}`;
      this.links[2].routerParams = {
        params: {
          ...this.$route.params,
        },
      };
    },
  },
  async mounted() {
    if (this.hasParams) {
      const payload = { id: this.$route.params.id };
      await this.consultCompanyCollaborators(payload);
      this.handleDataBreadcrumb();
    }
  },
};
</script>
